module.exports = __webpack_public_path__ + "media/images/preview-logo-ebac6bb4f515753666b64e92c2b723b6.png";